import "./App.css";
import React, { useState, useEffect, useContext } from "react";
import { DeviceManager } from "./globalManager/DeviceManager";
// import { LogManager } from "./globalManager/LogManagers";
import { LibraryManager } from "./globalManager/LibraryManager";
import { ResolutionManager } from "./globalManager/ResolutionManager";
import SplashScreen from "./components/SplashScreen";
import WelcomeScreen from "./components/WelcomeScreen";
import LoginScreen from "./components/LoginScreen";
import HomeScreen from "./components/HomeScreen";
import SearchScreen from "./components/SearchScreen";
import SelectedLanguage from "./components/SelectedLanguage";
import LoginOTP from "./components/LoginOTP";
import CategoryScreen from "./components/CategoryScreen";
import ViewAllScreen from "./components/ViewAllScreen";
import SettingsScreen from "./components/SettingsScreen";
import LiveScreen from "./components/LiveScreen";
import MyProfile from "./components/MyProfile";
import WatchlistScreen from "./components/WatchList";
import AddProfile from "./components/AddProfile";
import EditProfile from "./components/EditProfile";
import WhoWatching from "./components/WhoWatching";
import UpdateProfile from "./components/UpdateProfile";
import DeleteProfile from "./components/DeleteProfile";
import WhoAddProfile from "./components/WhoAddProfile";
import ManageDevices from "./components/ManageDevices";
import LiveTv from "./components/LiveTv";
// import useNetworkStatus from "./components/NetworkStatusCheck";
import CommonErrorMessagePopup from "./components/CommonErrorMessagePopup";
import { AppProvider, AppContext } from "./AppContext";
import useNetworkStatus from "./components/NetworkStatusCheck";

 
const App = () => {
  const { isLogedIn, screen, setScreen, errorPopup, lastScreen } =
    useContext(AppContext);
const { isOnline } = useNetworkStatus();
  const [screenData, setScreenData] = useState({});

  const navigate = (newScreenName, screenDataObj) => {
    console.log("debug 1702 :: navigate called",newScreenName,screen);
    if (newScreenName != screen) {
      console.log("debug 1702 :: ", newScreenName, screenDataObj);
      if (screenDataObj) {
        setScreenData(screenDataObj);
      }
      setScreen(newScreenName);

    }
    console.log("debug 1702 :: navigate called",screen);
  };

  useEffect(() => {
    console.log("samsung app useEffect");
    window.deviceManager = new DeviceManager();
    window.libraryManager = new LibraryManager();
    if (window.deviceManager.isSamsung()) {
      console.log("samsung app useEffect....");
      window.deviceManager.initTizenAPI();
    }else if (window.deviceManager.isLG()) {
      console.log("LG app useEffect");
      // LG webOS
      window.deviceManager.initWebOSAPI();
  }
    // LogManager();
  }, []);

useEffect(() => {
  if (isOnline) {
    const alreadyReloaded = sessionStorage.getItem("reloadedOnce");
 
    if (!alreadyReloaded) {
      sessionStorage.setItem("reloadedOnce", "true");
      window.location.reload();
    }
  } else {
    // When offline again → allow reload next time it reconnects
    sessionStorage.removeItem("reloadedOnce");
  }
}, [isOnline]);

  useEffect(() => {
    console.log("debug 2201 04", screen);
  }, [screen]);

  const splashComplete = () => {
    console.log("debug 2201 06", screen);
    let screenName;
    let isLogedInState = false;
    const token = localStorage.getItem("JWTToken");
    if (token) {
      screenName = "HomePage";
      isLogedInState = true;
    } else if (localStorage.getItem("AppLanguage")) {
      localStorage.setItem("LoginScreen", "LoginPage");
      screenName = "LoginScreen";
      isLogedInState = false;
      localStorage.removeItem("updateMyProfile");
    } else {
      screenName = "LanguagePage";
      isLogedInState = false;
    }
    console.log("debug 2201 03", screenName);
    if (screenName) {
      setScreen(screenName);
    }
  };

  useEffect(() => {
    if (errorPopup.show === "visible") {
      setScreen("ErrorScreen");
    } else if (errorPopup.show === "not visible") {
      setScreen(lastScreen);
    }
  }, [errorPopup]);

  let ScreenComponent;
  if (screen === "SplashScreen") {
    ScreenComponent = (
      <SplashScreen
        navigate={navigate}
        screenName={screen}
        splashComplete={splashComplete}
      />
    );
  } else if (screen === "WelcomeScreen") {
    ScreenComponent = (
      <WelcomeScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "LoginScreen") {
    ScreenComponent = <LoginScreen navigate={navigate} screenName="" />;
  } else if (screen === "HomePage") {
    ScreenComponent = (
      <HomeScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "SearchScreen") {
    ScreenComponent = (
      <SearchScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "LanguagePage") {
    ScreenComponent = (
      <SelectedLanguage
        navigate={navigate}
        screenName=""
        isLogedIn={isLogedIn}
      />
    );
  } else if (screen === "LoginOtpPage") {
    ScreenComponent = <LoginOTP navigate={navigate} screenName="" />;
  } else if (screen === "CategoryScreen") {
    ScreenComponent = (
      <CategoryScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "ViewAllScreen") {
    ScreenComponent = (
      <ViewAllScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} ViewAllData={screenData} />
    );
  } else if (screen === "SettingsScreen") {
    ScreenComponent = (
      <SettingsScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  }
  else if (screen === "LiveEventsScreen") {
    ScreenComponent = (
      <LiveTv navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  }
  else if (screen === "LiveScreen") {
    ScreenComponent = (
      <LiveScreen navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "ProfileScreen") {
    ScreenComponent = (
      <MyProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "WatchlistScreen") {
    ScreenComponent = (
      <WatchlistScreen
        navigate={navigate}
        screenName=""
        isLogedIn={isLogedIn}
      />
    );
  } else if (screen === "AddProfile") {
    ScreenComponent = (
      <AddProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "EditProfile") {
    ScreenComponent = (
      <EditProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "WhoWatching") {
    ScreenComponent = (
      <WhoWatching navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "UpdateProfile") {
    ScreenComponent = (
      <UpdateProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "DeleteProfile") {
    ScreenComponent = (
      <DeleteProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "WhoAddProfile") {
    ScreenComponent = (
      <WhoAddProfile navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  } else if (screen === "ManageDevices") {
    ScreenComponent = (
      <ManageDevices navigate={navigate} screenName="" isLogedIn={isLogedIn} />
    );
  }
  //  else if (screen === "ErrorScreen") {
  //   ScreenComponent = (
  //     // <div style={{
  //     //   position: "fixed",
  //     //   top: 0,
  //     //   left: 0,
  //     //   width: "100vw",
  //     //   height: "100vh",
  //     //   zIndex: 99999998,
  //     //   backdropFilter: "blur(5px)", // Add this line for background blur
  //     //   backgroundColor: "#0E1653",
  //     // }}>

  //     // </div>
  //     // <img src={base64Image} alt="background" style={{
  //     //   width: "100%",
  //     //   height: "100vh",
  //     //   objectFit: "cover",
  //     //   objectPosition: "center"
  //     // }} />
  //   );
  // }

  return (
    <div
      style={{
        fontFamily: "Anek Latin",
      }}
    >
      {ScreenComponent}
      <CommonErrorMessagePopup />
    </div>
  );
};

const AppWrapper = () => (
  <AppProvider>
    <App />
  </AppProvider>
);

export default AppWrapper;